import { jsx as _jsx } from "react/jsx-runtime";
import { Component_TagGroups } from '@app/hcs-frontend/tag';
import { Component_TagEditor, VariableWrapper } from '@app/hcs-frontend';
import { TS_CollapsableContainerV2 } from '@nu-art/thunderstorm-frontend';
import './Renderer_PathwayTags.scss';
export const Renderer_PathwayTags = (props) => {
    const tagGroups = props.pathway.item.tagGroups ?? [];
    const totalTags = tagGroups.reduce((sum, group) => sum + group.value.length, 0);
    const renderContent = () => {
        if (!props.editMode)
            return _jsx(Component_TagGroups, { tagGroups: tagGroups });
        const uiTagGroups = VariableWrapper.dbTagsToUI(tagGroups);
        return _jsx(Component_TagEditor, { tags: uiTagGroups, mandatoryRootTag: true, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id, onChange: async () => {
                const newTagGroups = VariableWrapper.getTagsForDB(uiTagGroups);
                await props.pathway.updateObj({ tagGroups: newTagGroups });
            } });
    };
    return _jsx(TS_CollapsableContainerV2, { className: 'pathway-tags', headerRenderer: () => `${totalTags} Tags`, containerRenderer: renderContent, animated: true, forceUpdate: true });
};
//# sourceMappingURL=Renderer_PathwayTags.js.map